import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({ name: 'Tabs' })(
  ({ brandColors, spacing, type }, props) => ({
    container: {
      display: 'flex',
      flexDirection: 'row',
      position: 'relative',
      color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
      ...type['16_regular'],
      borderRadius: '7.5px',
      background: darkOrLightStyle(props)(
        brandColors.primaryMain,
        brandColors.white
      ),
      overflow: 'hidden',
    },
    tab: {
      flexGrow: 1,
      textAlign: 'center',
      padding: `${spacing(-1)} ${spacing(1)}`,
      borderRadius: '5.333px',
      cursor: 'pointer',
      position: 'relative',
      zIndex: 1,
      transition: 'color 0.3s ease',
      background: 'transparent',
    },
    selected: {
      color: darkOrLightStyle(props)(brandColors.black, brandColors.white),
    },
    highlight: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      width: '50%',
      background: darkOrLightStyle(props)(
        brandColors.white,
        brandColors.primaryMain
      ),
      borderRadius: '7.5px',
      transition: 'transform 0.3s ease',
    },
  })
);

export default useStyles;
